<template>
    <div id="alarm">
        <Header />
        <div class="alarm_box">
            <div class="container">
                <h1>알림함</h1>
                <div class="box" v-for="(item, index) in alarmList" :key="index">
                    <img src="../assets/images/hot/col2.webp" alt="썸네일">
                    <div class="text">
                        <p class="title">아트포인트 충전 완료</p>
                        <p class="sub">ATT 입금이 확인되어 #### 아트포인트 충전이 완료되었습니다.</p>
                        <p class="day">2021.07.23<span>14:51</span></p>
                    </div>
                </div>
                <div class="paging" v-if="totalRecordSize > 0">
                    <a @click="prevPage()"><img src="../assets/images/arrow_left.svg" /></a>
                    <a class="current" v-if="pageList.length <= 0">1</a>
                    <a v-for="(item, index) in pageList" :key="index" :class="{'current' : item === currentPageNo}" @click="movePage(item)">{{item}}</a>
                    <a @click="nextPage()"><img src="../assets/images/arrow_right.svg" /></a>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
    name: 'Home',
        pageCategory: '',
        components: {
            Header,
            Footer,
    },
    data() {
        return {
            alarmList: [],

            currentPageNo: 1,      //현재 페이지 번호
            currentPageSize: 10,    //한번에 불러올 게시물 수
            maxPageCount:10,        //한 화면에 보여질 페이지 수

            listCount: 0,
            pageCount: 0,
            pageNo: 0,
            pageSize: 0,
            totalRecordSize: 0,

            pageList:[],

            isShowLoginPopup: false,
        }
    },
    async created(){
        await this.mixinSiteConfigCheck();

        this.getAlarmList();
    },
    methods: {
        prevPage(){
            if(this.currentPageNo > 1){
                this.currentPageNo--;
                this.getAlarmList();
            }
        },
        nextPage(){
            if(this.currentPageNo < this.pageCount){
                this.currentPageNo++;
                this.getAlarmList();
            }
        },
        movePage(no){
            if(this.currentPageNo === no)
                return;

            this.currentPageNo = no;
            this.getAlarmList();
        },
        changePage(){
            this.pageList = [];
            if(this.pageCount === 0)
                return;

            var tmpPageNo = this.currentPageNo - 2;
            if(this.currentPageNo + 2 > this.pageCount){
                tmpPageNo--;
            }
            if(this.currentPageNo +1 > this.pageCount){
                tmpPageNo--;
            }
            for(var i=0; i<5 && tmpPageNo <= this.pageCount; ){
                if(tmpPageNo >= 1){
                    this.pageList.push(tmpPageNo);
                    i++;
                }
                tmpPageNo++;   
            }
        },
        getAlarmList(){ //알람 리스트
            var param = 
            {
                category: this.currCategoryIdx,
                pageNo: this.currentPageNo,
                pageSize: this.currentPageSize,
                scending: this.currScending,
                sort: this.currSort,
                sign: this.$store.state.sign,
                ticket: this.$store.state.ticket,
                viewAdult: this.$store.state.isCheckedAdult ? 1 : 0
            }
            this.$Axios.post(`${this.host}/alarm/list`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(res => {
                console.log(res.data);
                if (res.data.returnCode === 0) {
                    this.categoryWebtoonList = res.data.list;
                    this.listCount       = res.data.page.listCount;
                    this.pageCount       = res.data.page.pageCount;
                    this.pageNo          = res.data.page.pageNo;
                    this.pageSize        = res.data.page.pageSize;
                    this.totalRecordSize = res.data.page.totalRecordSize;
                    this.changePage();
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
        moveDetail(item){
            
            if(item.adult === 1){
                if(this.$store.state.loginCheck === false){
                    this.isShowLoginPopup = true;
                }
                else if(!this.$store.state.adult){
                    var src = this.siteConfig.niceUrl + '?email=' + this.$store.state.email;
                    window.open(src, 'popupChk', 'width=500, height=550, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=no, location=no, scrollbar=no');
                }
                else{
                    // this.$router.push('/Toondetail/' + item.englishName);
                    this.$router.push('/Toondetail/' + item.webToonIndex);
                }
            }else{
                // this.$router.push('/Toondetail/' + item.englishName);
                this.$router.push('/Toondetail/' + item.webToonIndex);
            }
            
        },
        close(popupType){
            switch(popupType){
                case 'Login':
                    this.isShowLoginPopup = false;
                    break;
            }
        }
    }
}
</script>